/**
 * Fills in the outcome of the commission rule calculator. The form is a plain
 * GET form, so without JavaScript the page simply reloads with the scenario.
 */
const REFRESH_DELAY = 250;

const wholeAmount = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const exactAmount = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

function formatPrice(value) {
    const amount = Number(value);

    if (value === null || value === undefined || !Number.isFinite(amount)) {
        return '—';
    }

    return Number.isInteger(amount) ? `${wholeAmount.format(amount)},-` : exactAmount.format(amount);
}

function setup(form) {
    const panel = form.closest('section');
    const url = form.dataset.commissionCalculator;

    if (!panel || !url) {
        return;
    }

    const list = document.querySelector('[data-commission-rules]');
    const rules = list?.querySelectorAll('[data-commission-rule]') ?? [];
    const appliedClasses = (list?.dataset.commissionRulesAppliedClass || '').split(' ').filter((a) => a !== '');
    const fill = (selector, text) => {
        for (const target of panel.querySelectorAll(selector)) {
            target.textContent = text;
        }
    };

    let controller = null;
    let timer = null;

    const render = (outcome) => {
        panel.querySelector('[data-calculator-matched]').hidden = !outcome.matched;
        panel.querySelector('[data-calculator-unmatched]').hidden = outcome.matched;

        fill('[data-calculator-commission-percentage]', outcome.matched ? `${outcome.commissionPercentage}%` : '—');
        fill('[data-calculator-monthly-payment]', outcome.matched ? formatPrice(outcome.monthlyPayment) : '—');
        fill('[data-calculator-payout]', outcome.matched ? formatPrice(outcome.commission) : '—');

        for (const rule of rules) {
            if (rule.dataset.commissionRule === outcome.commissionRuleId) {
                rule.classList.add(...appliedClasses);
            } else {
                rule.classList.remove(...appliedClasses);
            }
        }
    };

    const refresh = () => {
        const query = new URLSearchParams(new FormData(form));

        controller?.abort();
        controller = new AbortController();

        fetch(`${url}?${query}`, { headers: { Accept: 'application/json' }, signal: controller.signal })
            .then((response) => (response.ok ? response.json() : Promise.reject(new Error('Calculation failed'))))
            .then((outcome) => {
                render(outcome);
                // Keep the scenario in the address bar so it survives a reload.
                window.history.replaceState(null, '', `${form.getAttribute('action')}?${query}`);
            })
            .catch(() => {
                // Keep the last outcome on screen; the next change tries again.
            });
    };

    // Typing and picking share one timer, so a change never refreshes twice.
    const scheduleRefresh = () => {
        clearTimeout(timer);
        timer = setTimeout(refresh, REFRESH_DELAY);
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        refresh();
    });
    form.addEventListener('input', scheduleRefresh);
    form.addEventListener('change', scheduleRefresh);
}

for (const form of document.querySelectorAll('form[data-commission-calculator]')) {
    setup(form);
}
